import axios from 'axios';

const SHOP_URL = process.env.NEXT_PUBLIC_SHOPIFY_STORE_URL || 'localprof.myshopify.com';
const STOREFRONT_TOKEN = process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_TOKEN;

export const storefrontClient = axios.create({
  baseURL: `https://${SHOP_URL}/api/2024-07/graphql.json`,
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
  },
});
